/* Keep the announcement in sync with Focal's native cart events. */
if (!customElements.get('header-shipping-progress')) {
  customElements.define('header-shipping-progress', class extends HTMLElement {
    connectedCallback() {
      this.message = this.querySelector('[data-shipping-message]');
      this.onUpdate = (event) => {
        if (event.detail && event.detail.cart) {
          this.revision = (this.revision || 0) + 1;
          this.renderCart(event.detail.cart);
        }
      };
      this.onRefresh = () => this.refreshCart();
      this.onPageShow = (event) => { if (event.persisted) this.refreshCart(); };
      document.documentElement.addEventListener('cart:updated', this.onUpdate);
      document.documentElement.addEventListener('cart:refresh', this.onRefresh);
      window.addEventListener('pageshow', this.onPageShow);
      // Header copy may wrap after a cart change; retain Focal's correct header offset.
      this.section = this.closest('.shopify-section--announcement-bar');
      this.resizeObserver = new ResizeObserver(() => {
        if (this.section) document.documentElement.style.setProperty('--announcement-bar-height', this.section.clientHeight + 'px');
      });
      if (this.section) this.resizeObserver.observe(this.section);
    }
    disconnectedCallback() {
      document.documentElement.removeEventListener('cart:updated', this.onUpdate);
      document.documentElement.removeEventListener('cart:refresh', this.onRefresh);
      window.removeEventListener('pageshow', this.onPageShow);
      this.resizeObserver?.disconnect();
      this.controller?.abort();
    }
    async refreshCart() {
      this.controller?.abort();
      this.controller = new AbortController();
      const revision = this.revision || 0;
      try {
        const response = await fetch(this.dataset.cartUrl, { signal: this.controller.signal, cache: 'no-store', headers: { Accept: 'application/json' } });
        if (!response.ok) return;
        const cart = await response.json();
        if (this.isConnected && revision === (this.revision || 0)) this.renderCart(cart);
      } catch (_) { /* Retain the server-rendered message if the request fails. */ }
    }
    renderCart(cart) {
      const threshold = Number(this.dataset.threshold);
      const total = Number(cart.original_total_price);
      if (!this.message || !(threshold > 0) || !Number.isFinite(total)) return;
      if (cart.currency !== 'USD') {
        this.message.textContent = 'Free U.S. shipping on orders of US$' + (threshold / 100) + '+';
        return;
      }
      const remaining = Math.max(0, threshold - total);
      if (remaining > 0) {
        const amount = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD', minimumFractionDigits: remaining % 100 ? 2 : 0, maximumFractionDigits: 2 }).format(remaining / 100);
        this.message.textContent = amount + ' more for free U.S. shipping';
      } else {
        this.message.textContent = cart.total_discount > 0
          ? 'Remove other discounts for free U.S. shipping'
          : "You've unlocked free U.S. shipping!";
      }
    }
  });
}
